<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{monitoringData.title}}</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <v-layout column>
          <v-flex>
            <v-layout row class="elevation-1 white mb-4 pa-3">
              <v-flex>
                <div class="mt-1">
                  <span class="title">Частота проверки не чаще чем раз в N дней:</span>
                  <span class="title font-weight-thin">{{monitoringData.frequency}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Максимальное число проверок: </span>
                  <span class="title font-weight-thin">{{monitoringData.max_checks}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Обязательно: </span>
                  <span class="title font-weight-thin">{{monitoringData.is_required ? 'Да' : 'Нет'}}</span>
                </div>
                <div class="mt-1">
                  <span class="title">Загруженный файл: </span>
                  <span class="title font-weight-thin"><a v-bind:href="monitoringData.product_xls_url" download>{{monitoringData.product_xls_title}}</a></span>
                </div>
                <div class="mt-1">
                  <span class="title">Результаты: </span>
                  <span class="title font-weight-thin"><a v-bind:href="monitoringData.result_url" download>загрузить</a></span>
                </div>
              </v-flex>
            </v-layout>

            <p class="title">Каналы продаж</p>
            <v-layout
              row
              v-if="channelList.length > 0"
              class="elevation-1 white mb-4 px-3 pt-3"
            >
              <v-flex xs12 lg6 md6>
                <div
                  v-for="(channel, index) in channelList"
                  :key="channel.id"
                >
                  <v-checkbox
                    disabled
                    :label="channel.title"
                    v-model="channelList[index].checked"
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
              </v-flex>
            </v-layout>

            <p class="title">Торговые точки</p>
            <v-layout row v-if="pointListTreeData !== null && pointListTreeData.length > 0" class="elevation-1 white mb-4 pa-3">
              <v-flex xs12 lg6 md6>
                <tree
                    :options="{
                        checkbox: true
                      }"
                    :data="pointListTreeData"
                    class="tree--small tree-single-page"
                />
              </v-flex>
            </v-layout>

            <p class="title">Товары конкурентов</p>
            <v-layout class="mb-4">
              <v-flex xs12>
                <v-data-table
                  :headers="ProductOuterHeaders"
                  :items="ProductOuterItems"
                  class="elevation-1 driver-single-table"
                  no-data-text="Нет данных"
                  hide-actions
                >
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                      <span>
                    {{ props.header.text }}
                  </span>
                    </v-tooltip>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-left"><b>{{ props.item.code }}</b></td>
                    <td class="text-xs-left">{{ props.item.title }}</td>
                    <td class="text-xs-left">{{ props.item.weight === null ? 'Весовой' : (props.item.weight + '&nbsp;кг') }}</td>
                    <td class="text-xs-left">{{ props.item.group }}</td>
                    <td class="text-xs-left">{{ props.item.factory }}</td>
                    <td class="text-xs-left">{{ props.item.check_photo }}</td>
                    <td class="text-xs-left">{{ props.item.check_barcode }}</td>
                    <td class="text-xs-left">{{ props.item.check_comment }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>

            <v-layout row class="pa-0 mt-3 mb-3">
              <v-flex xs12 lg12 md12>
                <div class="float-left inline-block">
                  <p class="title">Дата начала</p>
                  <v-date-picker
                      class="mr-3 ml-0 mt-0 mb-3"
                      locale="ru"
                      readonly
                      :value="$moment(monitoringData.start_date).format('YYYY-MM-DD')"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </div>
                <div class="inline-block">
                  <p class="title">Дата окончания</p>
                  <v-date-picker
                      class="mr-3 ml-0"
                      locale="ru"
                      readonly
                      :value="$moment(monitoringData.end_date).format('YYYY-MM-DD')"
                      :first-day-of-week="1"
                  ></v-date-picker>
                </div>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="actions.enabled"
        :right="true"
        :timeout="0"
        class="single-page-actions"
    >
      <div>
        <v-btn dark small color="primary" v-if="actions.canUpdate" @click="editMonitoring(id)">
          <v-icon dark>edit</v-icon>
        </v-btn>
        <v-btn dark small color="error" v-if="actions.canRemove" @click="deleteDialog = true">
          <v-icon dark>delete</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
    >
      <v-card>
        <v-card-title class="headline">Удалить мониторинг?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteMonitoringConfirm(id)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Мониторинги', link: '/monitorings/active'}
        ],
        ProductOuterHeaders: [
          {text: 'Код', sortable: false, value: 'code'},
          {text: 'Название', sortable: false, value: 'title'},
          {text: 'Вес', sortable: false, value: 'weight'},
          {text: 'Группа', sortable: false, value: 'group'},
          {text: 'Производитель', sortable: false, value: 'factory'},
          {text: 'Фото', sortable: false, value: 'check_photo'},
          {text: 'ШК', sortable: false, value: 'check_barcode'},
          {text: 'Комментарий', sortable: false, value: 'check_comment'}
        ],
        actions: {
          enabled: false,
          canUpdate: false,
          canRemove: false
        },
        id: null,
        pageDataReady: {
          isReady: false,
          distributionChannelList: false,
          monitoringData: false,
          branchList: false
        },
        channelIdList: [],
        channelList: [],
        pointListTreeData: [],
        pointFolderIdList: [],
        ProductOuterItems: [],
        pointIdList: [],
        productGroupList: [],
        deleteDialog: false,
        branch: null,
        branchId: null
      }
    },
    beforeCreate () {
      this.branch = null
      this.branchId = null

      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      this.$store.commit('setPageLoading', true)
      this.$store.dispatch('getMonitoringSingle', {id: this.$route.params.id})
    },
    computed: {
      monitoringData () {
        return this.$store.getters.monitoringSingle
      },
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      }
    },
    methods: {
      editMonitoring (id) {
        this.$router.push('/monitorings/edit/' + id)
      },
      deleteMonitoringConfirm () {
        this.deleteDialog = false
        this.$store.dispatch('deleteMonitoring', {id: this.id})
        this.$router.push('/monitorings/active/1')
      },
      pageDataStatus () {
        if (!this.pageDataReady.distributionChannelList) {
          return false
        }
        if (!this.pageDataReady.monitoringData) {
          return false
        }
        if (!this.pageDataReady.branchList) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== undefined && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
        } else {
          this.branchId = null
        }
        this.getStatisticsData()
      },
      pointTreeData (tree) {
        let treeData = []
        for (let i = 0; i < tree.length; i++) {
          treeData[i] = {
            text: tree[i].title,
            state: {
              expanded: true,
              disabled: true
            },
            children: []
          }

          if (typeof tree[i].point_folder_list !== 'undefined') {
            treeData[i].children = this.pointTreeData(tree[i].point_folder_list)
          }
          if (typeof tree[i].point_list !== 'undefined') {
            for (let k = 0; k < tree[i].point_list.length; k++) {
              treeData[i].children.push({text: tree[i].point_list[k].title, state: {checked: true}})
            }
          }

          if (treeData[i].children.length === 0) {
            treeData[i].state.checked = true
          } else {
            treeData[i].children.push({text: '', state: {checked: true, visible: false}})
            treeData[i].children.push({text: '', state: {checked: false, visible: false}})
          }
        }
        return treeData
      }
    },
    watch: {
      monitoringData (n, o) {
        this.pageDataReady.monitoringData = true
        this.pageDataStatus()

        if (typeof this.monitoringData.distribution_channel_list !== 'undefined') {
          this.channelIdList = []
          for (let i = 0; i < this.monitoringData.distribution_channel_list.length; i++) {
            this.channelIdList.push(this.monitoringData.distribution_channel_list[i].id)
          }
        }

        for (let i = 0; i < this.monitoringData.product_outer_list.length; i++) {
          let productOuter = this.monitoringData.product_outer_list[i]
          this.ProductOuterItems[i] = {
            code: productOuter.code,
            title: productOuter.title,
            weight: productOuter.weight,
            group: productOuter.group,
            factory: productOuter.factory,
            check_photo: productOuter.check_photo ? 'Да' : 'Нет',
            check_barcode: productOuter.check_barcode ? 'Да' : 'Нет',
            check_comment: productOuter.check_comment ? 'Да' : 'Нет'
          }
        }

        if (typeof this.monitoringData.point_folder_list !== 'undefined') {
          this.pointFolderIdList = []
          for (let i = 0; i < this.monitoringData.point_folder_list.length; i++) {
            this.pointFolderIdList.push(this.monitoringData.point_folder_list[i].id)
          }
        }

        if (typeof this.monitoringData.point_list !== 'undefined') {
          this.pointIdList = []
          for (let i = 0; i < this.monitoringData.point_list.length; i++) {
            this.pointIdList.push(this.monitoringData.point_list[i].id)
          }
        }

        if (typeof this.monitoringData.monitoring_product_group_list !== 'undefined') {
          this.productGroupList = []
          for (let i = 0; i < this.monitoringData.monitoring_product_group_list.length; i++) {
            this.productGroupList[i] = {
              title: this.monitoringData.monitoring_product_group_list[i].title,
              skuList: [],
              id: this.monitoringData.monitoring_product_group_list[i].id
            }

            for (let k = 0; k < this.monitoringData.monitoring_product_group_list[i].product_sku_list.length; k++) {
              this.productGroupList[i].skuList[k] = this.monitoringData.monitoring_product_group_list[i].product_sku_list[k].title
            }
          }
        }

        if (typeof this.monitoringData.point_folder_tree !== 'undefined') {
          this.pointListTreeData = this.pointTreeData(this.monitoringData.point_folder_tree)
        }

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Мониторинги', link: '/monitorings/active'}
        ]
        this.breadcrumbs.push({name: this.monitoringData.title})

        this.$store.commit('setPageTitle', this.monitoringData.title)

        this.$store.dispatch('getDistributionChannelList')
          .then(() => {
            this.pageDataReady.distributionChannelList = true
            this.pageDataStatus()
          })

        this.id = this.monitoringData.id
        if (this.monitoringData.mode === 'active') {
          this.actions.enabled = true
        } else {
          this.actions.enabled = false
        }

        this.actions.canUpdate = this.monitoringData.can_update
        this.actions.canRemove = this.monitoringData.can_remove
      },
      distributionChannelList (n, o) {
        this.channelList = []
        for (let i = 0; i < this.distributionChannelList.length; i++) {
          this.channelList[i] = this.distributionChannelList[i]
        }

        if (this.channelIdList.length > 0) {
          for (let i = 0; i < this.channelList.length; i++) {
            let position = this.channelIdList.indexOf(this.channelList[i].id)
            if (~position) {
              this.channelList[i].checked = true
            } else {
              this.channelList[i].checked = false
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Monitorings/MonitoringSingle.vue